import { RefreshCcw, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { scrollToId } from "../lib/scroll";

export const GoldExchange = () => (
  <section id="gold-exchange" data-testid="gold-exchange-section" className="py-20 md:py-32 bg-[#F7F1E6]">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-12 gap-10 items-center border border-gold/30 bg-ivory rounded-sm p-8 md:p-14">
        <Reveal className="md:col-span-2 flex md:justify-center">
          <span className="w-20 h-20 rounded-full border border-gold/50 flex items-center justify-center">
            <RefreshCcw size={30} strokeWidth={1} className="text-gold-muted" />
          </span>
        </Reveal>
        <div className="md:col-span-7">
          <Reveal>
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-gold-muted mb-3">Gold Exchange</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-royal-deep tracking-tight leading-tight">
              Exchange Your Gold With Confidence
            </h2>
            <p className="mt-5 text-base md:text-lg font-light text-charcoal/70 leading-relaxed max-w-xl">
              Visit our showroom to discuss gold exchange. Every evaluation is done transparently, right in front of you, and our team explains the value clearly before you decide. Current exchange value is shared in-store based on the day's assessment.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="md:col-span-3 md:text-right">
          <button
            data-testid="gold-exchange-enquire-button"
            onClick={() => scrollToId("enquiry")}
            className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-royal text-ivory text-sm tracking-[0.12em] uppercase font-medium rounded-sm hover:bg-royal-light transition-colors duration-300"
          >
            Enquire About Gold Exchange <ArrowRight size={14} strokeWidth={1.5} />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
